import "./welComePage.scss";
import React from "react";
import { useNavigate } from "react-router-dom";
import Btton from "../../components/Start-Btn/StartBtn";
import "@fontsource/roboto";
import "@fontsource/roboto/700.css";
import AssignmentIcon from "@mui/icons-material/Assignment";
import BadgeIcon from "@mui/icons-material/Badge";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import SecurityIcon from "@mui/icons-material/Security";

const WelComePage = () => {
  const navigate = useNavigate();

  return (
    <div className="containor">
      <div className="containor-wrapper">
        <div className="top">
          <h1 className="title" style={{ fontFamily: "Roboto" }}>
            Welcome to Cinnamon Lakehouse
          </h1>
          <div className="divider" />
          <p className="subtitle" style={{ fontFamily: "Roboto" }}>
            Experience a seamless arrival. Complete your pre-registration online in just a few steps.
          </p>
        </div>

        <div className="steps-container">
          <div className="step-card">
            <div className="step-icon-wrapper">
              <AssignmentIcon className="step-icon" />
            </div>
            <div className="step-content">
              <h3 style={{ fontFamily: "Roboto" }}>1. Reference ID</h3>
              <p style={{ fontFamily: "Roboto" }}>Verify your booking using your reservation reference ID.</p>
            </div>
          </div>

          <div className="step-card">
            <div className="step-icon-wrapper">
              <BadgeIcon className="step-icon" />
            </div>
            <div className="step-content">
              <h3 style={{ fontFamily: "Roboto" }}>2. Guest Details</h3>
              <p style={{ fontFamily: "Roboto" }}>Add details for all guests staying under your reservation.</p>
            </div>
          </div>

          <div className="step-card">
            <div className="step-icon-wrapper">
              <CloudUploadIcon className="step-icon" />
            </div>
            <div className="step-content">
              <h3 style={{ fontFamily: "Roboto" }}>3. Document Upload</h3>
              <p style={{ fontFamily: "Roboto" }}>Upload Passport/NIC images for secure verification.</p>
            </div>
          </div>
        </div>

        <div className="gdpr-box">
          <SecurityIcon className="gdpr-icon" />
          <p style={{ fontFamily: "Roboto" }}>
            Your personal data is protected in compliance with the General Data Protection Regulation (GDPR) and will not be shared with third parties.
          </p>
        </div>

        <div className="bottom">
          <Btton
            name="Get Started"
            onClick={() => {
              navigate("/addreference");
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default WelComePage;
